import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-card-practices',
  templateUrl: './card-practices.component.html',
  styleUrls: ['./card-practices.component.scss']
})
export class CardPracticesComponent implements OnInit {

  @Input() cardInfo:any;
  @Input() token = true;
  @Input() post = false;
  @Input() index = -1;

  @Input() download = false;
  href = '';

  constructor() { }

  ngOnInit() {


    if (this.cardInfo.institution) {
      this.cardInfo.title = this.cardInfo.title;
      this.cardInfo.date = this.cardInfo.creationDate;
    }

    if (this.cardInfo.reqAuth != undefined || this.cardInfo.institution) {
      this.cardInfo.class = true;

    }

    if (this.cardInfo.name) {
      this.cardInfo.title = this.cardInfo.name;
    }

    if (this.cardInfo.reqAuth != undefined) {
       this.cardInfo.title = this.cardInfo.name;
       this.download = true;
       this.cardInfo.date2 = this.cardInfo.publicationDate;
       // this.cardInfo.token = '/'+this.cardInfo.url;
    }

    if (this.post) {
      this.cardInfo.token = `/practicas/${this.cardInfo.token}`;
    }


    if (this.token && !this.download) {
      this.cardInfo.token = (this.cardInfo.token) ? this.cardInfo.token : '/noticias';
    }

  }

}
